export const EMPTY_ELK_EDGE_PATHS = Object.freeze({});

/**
 * Task/decision card roots that carry canvas translate (excludes handles layer
 * elements that also use data-task-id).
 */
export const LAYOUT_FLIP_NODE_SELECTOR =
  '.task-node[data-task-id], .decision-node[data-task-id], .milestone-node[data-task-id]';

/** Single layout shell for a task id (attribute selector; ids are stable UUIDs). */
export function layoutPositionedNodeSelector(taskId) {
  return [
    `.task-node[data-task-id="${taskId}"]`,
    `.decision-node[data-task-id="${taskId}"]`,
    `.milestone-node[data-task-id="${taskId}"]`,
  ].join(', ');
}

/** Stamped on async ELK results — must equal current layoutVersion to use ELK. */
export const ELK_FOR_LAYOUT_VERSION = '__elkForLayoutVersion';

/** Full tidy / auto-layout slide (FLIP in useElkAsyncLayoutEffect). */
export const LAYOUT_ANIMATION_DURATION = 320;
/** Same curve as node FLIP — camera and cards must ease together. */
export const LAYOUT_ANIMATION_EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
/** When position delta vs last commit is small, use a shorter transition. */
export const LAYOUT_ANIMATION_DURATION_SMALL_DELTA = 120;
export const LAYOUT_ANIMATION_DELTA_SNAP_PX = 28;

export const EDGE_FADE_IN_DURATION = 250;

/** After all node dimensions exist, bump layoutVersion (was 300ms — shorter feels snappier). */
export const POST_MEASURE_ELK_DELAY_MS = 72;

/** Debounce before ELK re-run when card measurements change (show/hide fields). */
export const ELK_RELAYOUT_ON_DIMS_DEBOUNCE_MS = 120;

/** Saved positions within this of fresh ELK auto = same layout; silently re-align on settle. */
export const SNAP_SAVED_TO_ELK_MAX_DELTA_PX = 16;
/** Ignore sub-pixel noise — only persist a snap when something actually moved. */
export const SNAP_SAVED_TO_ELK_MIN_DELTA_PX = 0.75;

/** Never keep edges hidden longer than this while waiting for ELK (worker failure etc.). */
export const EDGES_AWAITING_ELK_MAX_HIDE_MS = 1500;

/**
 * Cap for the full-screen animation blocker + `flowchart--animating-layout`.
 * Tidy hides edges and swallows clicks until ELK reveals them. If that pass is
 * cancelled, skipped, or hangs (large paste), the board would otherwise stay
 * frozen — stacked cards, no edges, no click-to-deselect.
 */
export const LAYOUT_BLOCKER_SAFETY_MS = 2500;

/**
 * Structural tidy (connect / delete / Tidy button): block implicit + instant ELK
 * so a follow-up remasure cannot snap over the FLIP. Safety-cleared if FLIP never finishes.
 */
export const LAYOUT_HOLD_SAFETY_MS = 1200;
